"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3388],{

/***/ 53388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ QuoteShowcase_QuoteShowcase; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
;// CONCATENATED MODULE: ./blocks/QuoteShowcase/QuoteShowcase.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 66%;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  max-width: 85%;\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 1rem;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 45.25rem;\n    border-radius: 7.5rem;\n    padding: 4rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 70vh;\n  border-radius: 2.75rem;\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 1.5rem;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            top: 6rem;\n          "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          top: 1.5rem;\n          background: white;\n          width: 100%;\n          height: 1px;\n          ",
        "\n        "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            left: 6rem;\n          "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          left: 1.5rem;\n          background: white;\n          width: 1px;\n          height: 100%;\n          ",
        "\n        "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            bottom: 6rem;\n          "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          bottom: 1.5rem;\n          background: white;\n          width: 100%;\n          height: 1px;\n          ",
        "\n        "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            right: 6rem;\n          "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          right: 1.5rem;\n          background: white;\n          width: 1px;\n          height: 100%;\n          ",
        "\n        "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  mix-blend-mode: difference;\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}




const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12b2fb36-0"
})(_templateObject(), ()=>(0,padding/* blockPadV */.zr)(), ()=>(0,padding/* blockPadH */.XA)());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12b2fb36-1"
})(_templateObject1(), ()=>(0,padding/* blockW */.g5)());
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12b2fb36-2"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject2());
});
const Quote = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-12b2fb36-3"
})(_templateObject4());
const CreditedTo = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-12b2fb36-4"
})(_templateObject5());
const Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12b2fb36-5"
})(_templateObject7(), (param)=>{
    let { bgImage  } = param;
    return bgImage ? "url(".concat(bgImage, ")") : "url('/uploads/GFX_bg01.png')";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject6());
});
const alignments = (/* unused pure expression or super */ null && ([
    "top",
    "left",
    "bottom",
    "right"
]));
const FrameLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12b2fb36-6"
})(_templateObject16(), (param)=>{
    let { align  } = param;
    switch(align){
        case "top":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), (param)=>{
                let { theme  } = param;
                return theme.mq.md(_templateObject8());
            });
        case "left":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), (param)=>{
                let { theme  } = param;
                return theme.mq.md(_templateObject10());
            });
        case "bottom":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), (param)=>{
                let { theme  } = param;
                return theme.mq.md(_templateObject12());
            });
        case "right":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject15(), (param)=>{
                let { theme  } = param;
                return theme.mq.md(_templateObject14());
            });
        default:
            break;
    }
});
const ImageFrame = (param)=>{
    let { children , bgImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
        bgImage: bgImage || "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameLine, {
                align: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameLine, {
                align: "left"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameLine, {
                align: "bottom"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameLine, {
                align: "right"
            }),
            children
        ]
    });
};
const QuoteShowcase = (param)=>{
    let { text , subtext , asset  } = param;
    const bgImage = asset === null || asset === void 0 ? void 0 : asset.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFrame, {
                bgImage: bgImage || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote, {
                            children: text
                        }),
                        subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditedTo, {
                            children: subtext
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var QuoteShowcase_QuoteShowcase = (QuoteShowcase);

;// CONCATENATED MODULE: ./blocks/QuoteShowcase/index.ts



/***/ })

}]);